<template>
    <CRow alignVertical="center">
        <CCol md="12" sm="12">
            <h5>
                {{ $t("Update enabled") }}
            </h5>
            <p class="mb-1">
                {{ $t("Facilitate to update the contact if already exist.") }}.
            </p>

            <CSwitch
                :checked.sync="settings.updateEnabled"
                color="primary"
                name="action"
                shape="pill"
                variant="3d"
                size="sm"
            />
        </CCol>
        <CCol md="12" sm="12">
            <h5>
                {{ $t("Fields mapping") }}
            </h5>

            <CCTableAddItems
                :items.sync="settings.fieldsMapping"
                :fields="[
                    {
                        key: 'dataType',
                        label: 'Data type',
                    },
                    {
                        key: 'mappingName',
                        label: 'Mapping name',
                    },
                ]"
                :resizable="false"
            >
                <template #dataType="{ item }">
                    <SelectAsync
                        :value.sync="item.dataType"
                        :options="payload"
                        :placeholder="$t('Select a field')"
                        :invalidFeedback="$t('Field is requiered')"
                        size="sm"
                        class="mb-0"
                    />
                </template>
                <template #mappingName="{ item }">
                    <SelectAsync
                        :value.sync="
                            item.mappingName
                        "
                        :placeholder="$t('Select an option')"
                        size="sm"
                        :options="fieldsFromApiLeadsToContact"
                        optionsValue="api_name"
                        optionsLabel="display_label"
                    />
                </template>
            </CCTableAddItems>
        </CCol>
        <CCol md="12" sm="12">
            <h5>
                {{ $t("Fixed fields") }}
            </h5>
            <p class="mb-0">
                {{ $t("You can create fixed fields for your integration") }}.
            </p>
            <CCTableAddItems
                :items.sync="settings.fixedFields"
                :fields="[
                    {
                        key: 'name',
                        label: 'Field name',
                    },
                    {
                        key: 'value',
                        label: 'Field value',
                    },
                ]"
                :resizable="false"
            >
                <template #name="{ item }">
                    <SelectAsync
                        :value.sync="item.name"
                        :placeholder="$t('Select an option')"
                        size="sm"
                        :options="fieldsFromApiLeadsToContact"
                        optionsValue="api_name"
                        optionsLabel="display_label"
                    />
                </template>
                <template #value="{ item }">
                    <SelectTags
                        v-if="
                            findFieldFromApiLeadsToContactSelected(
                                item.name
                            ) &&
                            findFieldFromApiLeadsToContactSelected(
                                item.name
                            )['data_type'] == 'multiselectpicklist'
                        "
                        :onlyValue="true"
                        size="sm"
                        :value.sync="item.value"
                        :options="
                            findFieldFromApiLeadsToContactSelected(
                                item.name
                            )['pick_list_values']
                        "
                        optionsValue="display_value"
                        optionsLabel="display_value"
                    />
                    <SelectAsync
                        v-else-if="
                            findFieldFromApiLeadsToContactSelected(
                                item.name
                            ) &&
                            findFieldFromApiLeadsToContactSelected(
                                item.name
                            )['data_type'] == 'picklist'
                        "
                        :value.sync="item.value"
                        :placeholder="$t('Select an option')"
                        size="sm"
                        :options="
                            findFieldFromApiLeadsToContactSelected(
                                item.name
                            )['pick_list_values']
                        "
                        optionsValue="display_value"
                        optionsLabel="display_value"
                    />
                    <CInput
                        v-else-if="
                            findFieldFromApiLeadsToContactSelected(
                                item.name
                            )
                        "
                        :value.sync="item.value"
                        :placeholder="$t('enter_the_value')"
                        :invalidFeedback="$t('value_is_required')"
                        class="mb-0"
                        size="sm"
                    />
                </template>
            </CCTableAddItems>
        </CCol>
    </CRow>
</template>

<script>
import TableFixedFields from "~/components/TableFixedFields.vue";
import CustomTable from "~/components/CustomTable";
import CCTableAddItems from "~/components/CCTableAddItems";
import ButtonAdd from "~/components/ButtonAdd";
import SelectAsync from "£lement/SelectAsync";
import SelectTags from "£lement/SelectTags";

import tableMixin from "~/mixins/table.js";
import baseMixin from "~/mixins/base.js";

import {
    cilSave,
    cilArrowThickFromRight,
    cilSettings,
    cilPencil,
    cilTrash,
    cilPlus,
} from "@coreui/icons";
import { ZOHO_GET_FIELDS_FROM_API_LEADS_TO_CONTACT_ACTION_ID } from "~/pages/app/Services/Triggers/Config/Types";

export default {
    name: "ZohoCreateLeadToContactActionSettings",
    mixins: [baseMixin, tableMixin],
    icons: {
        cilSave,
        cilArrowThickFromRight,
        cilSettings,
        cilPencil,
        cilTrash,
        cilPlus,
    },
    consts: {
        ZOHO_GET_FIELDS_FROM_API_LEADS_TO_CONTACT_ACTION_ID,
    },
    options: {},
    components: {
        TableFixedFields,
        CustomTable,
        CCTableAddItems,
        SelectAsync,
        ButtonAdd,
        SelectTags,
    },
    data() {
        return {
            settings: {
                useEmail: true,
                usePhone: true,
                fixedFields: [],
                fieldsMapping: [],
                updateEnabled: false,
            },
            fieldsFromApiLeadsToContact: [],
        };
    },
    props: {
        payload: {
            required: true,
        },
        value: {
            required: true,
        },
        integration: {
            require: true,
        },
    },
    watch: {
        value(newValue) {
            this.settings.fixedFields = newValue.fixedFields || [];
            this.settings.fieldsMapping = newValue.fieldsMapping || [];
            this.settings.updateEnabled = newValue.updateEnabled || false;
        },
        settings: {
            handler(newValue) {
                
                this.$emit("update:value", newValue);
                this.$emit("change", newValue);
            },
            deep: true,
        },
    },
    methods: {
        async loadFieldsFromApiLeadsToContact() {
            let data = await this.fetcher({
                url: `/connector.api/integrations/${this.integration.uuid}/actions/${this.$options.consts.ZOHO_GET_FIELDS_FROM_API_LEADS_TO_CONTACT_ACTION_ID}/execute`,
            });
            this.fieldsFromApiLeadsToContact = data.pluginActionResponse.fields;
        },
        findFieldFromApiLeadsToContactSelected(apiName) {
            return this.fieldsFromApiLeadsToContact.find((field) => {
                return field["api_name"] == apiName;
            });
        },
    },
    async mounted() {
        this.settings.fixedFields = this.value.fixedFields || [];
        this.settings.fieldsMapping = this.value.fieldsMapping || [];
        this.settings.updateEnabled = this.value.updateEnabled || false;
        await this.loadFieldsFromApiLeadsToContact();
    },
};
</script>

<style>
.range__not_defined {
    accent-color: gray;
}
</style>
